import React from 'react';
import { Table, Tag } from "antd"
import uid from 'uid';
import moment from 'moment';
import { toBRL } from '~/components/UI/InputCurrency';
import { methods as paymentMethods } from '~/helpers/paymentMethods';
import { getDefaultPaginationConfig } from '~/utils/get-default-pagination-config';
import { STORAGE } from '~/constants/storage.constants';

const { Column } = Table;

export const InstallmentsTable = ({
  payment,
  billsData,
}) => {
  return (
    <Table
      size="small"
      dataSource={payment ? payment.installments : Object.values(billsData.payments).map((data, index, array) => ({
        id: uid(10),
        quota: `${index + 1}/${array.length}`,
        due_date: data.due_date,
        amount: data.amount,
        method: data.method,
        status: 'Pendente'
      }))}
      rowKey="id"
      bodyStyle={{margin: 0}}
      pagination={{
        ...getDefaultPaginationConfig({ storageKey: STORAGE.defaultPageSize.partnersInstallments }),
        hideOnSinglePage: true,
        showSizeChanger: false,
        size: 'small',
      }}
    >
      <Column title="Parcela" dataIndex="quota" key="quota" align="center" />
      <Column title="Vencimento" dataIndex="due_date" key="due_date" render={function(date) { return moment(date).format('DD/MM/YYYY'); }} align="center" />
      <Column title="Valor" dataIndex="amount" key="amount" render={function(amount) { return 'R$ ' + toBRL(amount); }} align="center" />
      <Column title="Forma PGTO" dataIndex="method" key="method" render={function(method) { var m = paymentMethods.find(function(d) { return d.value === method; }); return m ? m.name : method; }} align="center" />
      <Column title="Status" dataIndex="status" key="status" render={function(status) {
        var color = status === 'Pago' ? '#52c41a' : '#fa8c16';
        var bg = status === 'Pago' ? '#f6ffed' : '#fff7e6';
        var border = status === 'Pago' ? '#b7eb8f' : '#ffd591';
        return (
          <span style={{
            display: 'inline-block',
            padding: '1px 8px',
            borderRadius: 10,
            fontSize: 11,
            fontWeight: 500,
            color: color,
            background: bg,
            border: '1px solid ' + border
          }}>
            {status}
          </span>
        );
      }} align="center" />
    </Table>
  )
}